// src/admin/AdminLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../services/adminAuth.api";

function AdminLogin() {
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");


    const handleLogin = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError("");

  try {
    const res = await adminLogin({ username, password });

    localStorage.setItem("adminToken", res.token);
    localStorage.setItem("adminUser", JSON.stringify(res.admin));

    localStorage.setItem(
  "staffPermissions",
  JSON.stringify(res.permissions || {})
);


    navigate("/admin/dashboard");
  } catch (err) {
    setError(err.message || "Login failed");
  } finally {
    setLoading(false);
  }
};


    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
            <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-md">

                <h1 className="text-3xl font-bold text-center text-cyan-700 mb-6">
                    Admin Login
                </h1>

                {/* Error Message */}
                {error && (
                    <div className="bg-red-100 text-red-700 p-3 rounded-lg mb-4 animate-pulse">
                        {error}
                    </div>
                )}

                <form onSubmit={handleLogin} className="space-y-4">
                    <input
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400 outline-none"
                    />

                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400 outline-none"
                    />

                    <button
                        type="submit"
                        disabled={loading}
                        className="
                            w-full bg-cyan-600 text-white py-3 rounded-xl font-bold
                            hover:bg-cyan-700 transition shadow-lg
                        "
                    >
                        {loading ? "Logging in..." : "Login"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AdminLogin;
